// extracted by mini-css-extract-plugin
export default {"content":"SidebarLayout_content__3KSPV","section":"SidebarLayout_section__PoZ+2"};